'use strict';
import * as $j_app$002edata$002e$002dImmu$002dD$002dB$002dData$002dCenter$002dId from "./app.data.-Immu-D-B-Data-Center-Id.js";
import * as $j_app$002edata$002e$002dImmu$002dD$002dB$002dData$002dCenter$002dId$0024$0024anon$00241 from "./app.data.-Immu-D-B-Data-Center-Id$$anon$1.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
function $s_Lapp_data_ImmuDBDataCenterId$___0__Lapp_data_ImmuDBDataCenterId() {
  $m_Lapp_data_ImmuDBDataCenterId$();
  return $t_Lapp_data_ImmuDBDataCenterId$___0;
}
export { $s_Lapp_data_ImmuDBDataCenterId$___0__Lapp_data_ImmuDBDataCenterId as $s_Lapp_data_ImmuDBDataCenterId$___0__Lapp_data_ImmuDBDataCenterId };
/** @constructor */
function $c_Lapp_data_ImmuDBDataCenterId$() {
  this.aBA = null;
  this.aBB = null;
  this.aBC = false;
  this.aBD = null;
  this.aBE = false;
  $n_Lapp_data_ImmuDBDataCenterId$ = this;
  $t_Lapp_data_ImmuDBDataCenterId$___0 = new $j_app$002edata$002e$002dImmu$002dD$002dB$002dData$002dCenter$002dId$0024$0024anon$00241.$c_Lapp_data_ImmuDBDataCenterId$$anon$1("_0", 0);
  this.aBA = new ($j_app$002edata$002e$002dImmu$002dD$002dB$002dData$002dCenter$002dId.$d_Lapp_data_ImmuDBDataCenterId.r().C)([$s_Lapp_data_ImmuDBDataCenterId$___0__Lapp_data_ImmuDBDataCenterId()]);
}
export { $c_Lapp_data_ImmuDBDataCenterId$ as $c_Lapp_data_ImmuDBDataCenterId$ };
$p = $c_Lapp_data_ImmuDBDataCenterId$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_ImmuDBDataCenterId$;
/** @constructor */
function $h_Lapp_data_ImmuDBDataCenterId$() {
}
export { $h_Lapp_data_ImmuDBDataCenterId$ as $h_Lapp_data_ImmuDBDataCenterId$ };
$h_Lapp_data_ImmuDBDataCenterId$.prototype = $p;
$p.bJF = (function(ordinal) {
  try {
    return this.aBA.a[ordinal];
  } catch (e) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_ju_NoSuchElementException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_ju_NoSuchElementException(), (("enum app.data.ImmuDBDataCenterId has no case with ordinal: " + "") + ordinal));
  }
});
$p.Au = (function() {
  if ((!this.aBC)) {
    this.aBB = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_CirceKeyCodec$().bIT(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((ordinal) => {
      var ordinal$1 = (ordinal | 0);
      return $m_Lapp_data_ImmuDBDataCenterId$().bJF(ordinal$1);
    })));
    this.aBC = true;
  }
  return this.aBB;
});
$p.bNs = (function() {
  if ((!this.aBE)) {
    this.aBD = new $c_Lapp_data_ImmuDBDataCenterId$$anon$2();
    this.aBE = true;
  }
  return this.aBD;
});
$p.dl = (function(x) {
  return x.ahG;
});
var $d_Lapp_data_ImmuDBDataCenterId$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_ImmuDBDataCenterId$, "app.data.ImmuDBDataCenterId$", ({
  DN: 1,
  d: 1,
  D: 1
}));
export { $d_Lapp_data_ImmuDBDataCenterId$ as $d_Lapp_data_ImmuDBDataCenterId$ };
var $n_Lapp_data_ImmuDBDataCenterId$;
function $m_Lapp_data_ImmuDBDataCenterId$() {
  if ((!$n_Lapp_data_ImmuDBDataCenterId$)) {
    $n_Lapp_data_ImmuDBDataCenterId$ = new $c_Lapp_data_ImmuDBDataCenterId$();
  }
  return $n_Lapp_data_ImmuDBDataCenterId$;
}
export { $m_Lapp_data_ImmuDBDataCenterId$ as $m_Lapp_data_ImmuDBDataCenterId$ };
/** @constructor */
function $c_Lapp_data_ImmuDBDataCenterId$$anon$2() {
}
export { $c_Lapp_data_ImmuDBDataCenterId$$anon$2 as $c_Lapp_data_ImmuDBDataCenterId$$anon$2 };
$p = $c_Lapp_data_ImmuDBDataCenterId$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_ImmuDBDataCenterId$$anon$2;
/** @constructor */
function $h_Lapp_data_ImmuDBDataCenterId$$anon$2() {
}
export { $h_Lapp_data_ImmuDBDataCenterId$$anon$2 as $h_Lapp_data_ImmuDBDataCenterId$$anon$2 };
$h_Lapp_data_ImmuDBDataCenterId$$anon$2.prototype = $p;
$p.aT = (function(t) {
  return $m_Lapp_data_ImmuDBDataCenterId$().Au().vK(t);
});
var $d_Lapp_data_ImmuDBDataCenterId$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_ImmuDBDataCenterId$$anon$2, "app.data.ImmuDBDataCenterId$$anon$2", ({
  DP: 1,
  a: 1,
  aO: 1,
  aN: 1
}));
export { $d_Lapp_data_ImmuDBDataCenterId$$anon$2 as $d_Lapp_data_ImmuDBDataCenterId$$anon$2 };
var $t_Lapp_data_ImmuDBDataCenterId$___0 = null;
function $u_Lapp_data_ImmuDBDataCenterId$___0(x) {
  $t_Lapp_data_ImmuDBDataCenterId$___0 = x;
}
export { $t_Lapp_data_ImmuDBDataCenterId$___0 as $t_Lapp_data_ImmuDBDataCenterId$___0, $u_Lapp_data_ImmuDBDataCenterId$___0 as $u_Lapp_data_ImmuDBDataCenterId$___0 };
//# sourceMappingURL=app.data.-Immu-D-B-Data-Center-Id$.js.map
